import automaticUpdateDisabled from './automatic-update-disabled'
import changeOne from './change-one'
import commandHandler from './command-handler'
import context from './context'
import copyButton from './copy-button'
import macrotrendList from './macrotrend-list'
import megatrendList from './megatrend-list'
import universeInfo from './universe-info'
import universeTrendFilter from './universe-trend-filter'

export default {
    automaticUpdateDisabled,
    changeOne,
    commandHandler,
    context,
    copyButton,
    macrotrendList,
    megatrendList,
    universeInfo,
    universeTrendFilter
}
